<template>
  <div :class="this.mobile ? 'mobile' : 'pc'">
    <div :class="sidebar.isFold ? 'container' : 'container1'">
      <!-- 状态模块 -->
      <div
        class="item1"
        data-step="1"
        :data-intro="$t('map.intro.dataIntro1')"
        :data-title="$t('map.intro.dataTitle1')"
      >
        <el-row :gutter="5">
          <div class="statusList">
            <el-card class="img1">
              <div>
                <img
                  src="@/assets/images/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'ja'"
                />
                <img
                  src="@/assets/imagesHK/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'HK'"
                />
                <img
                  src="@/assets/imagesKegoo/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Kegoo'"
                />
                <img
                  src="@/assets/imagesMINI/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'MINI'"
                />
                <img
                  src="@/assets/imagesOlar/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Olar'"
                />
                <img
                  src="@/assets/imagesHKCarton/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Carton'"
                />
                <img
                  src="@/assets/imagesJAMINI/RVM1.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'JAMINI'"
                />
                <div class="statusNum">
                  <div :class="mobile ? 'mstatusData1' : 'statusData1'">
                    <div class="statusData">
                      <div :class="mobile ? 'mrvm' : 'rvm'">RVM</div>
                      <div :class="mobile ? 'mrvm monline' : 'rvm online'">
                        {{ $t("map.online") }}
                      </div>
                    </div>
                    <span :class="mobile ? 'mtotalDate' : 'totalDate'">{{
                      this.totalDate.online
                    }}</span>
                  </div>
                  <div
                    :class="mobile ? 'msearch' : 'search'"
                    @click="jumptoMachine(totalDate, 'online')"
                  >
                    {{ $t("map.view") }}
                  </div>
                </div>
              </div>
            </el-card>
            <el-card class="img2">
              <div>
                <img
                  src="@/assets/images/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'ja'"
                />
                <img
                  src="@/assets/imagesHK/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'HK'"
                />
                <img
                  src="@/assets/imagesKegoo/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Kegoo'"
                />
                <img
                  src="@/assets/imagesMINI/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'MINI'"
                />
                <img
                  src="@/assets/imagesOlar/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Olar'"
                />
                <img
                  src="@/assets/imagesHKCarton/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Carton'"
                />
                <img
                  src="@/assets/imagesJAMINI/RVM3.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'JAMINI'"
                />
                <div class="statusNum">
                  <div :class="mobile ? 'mstatusData1' : 'statusData1'">
                    <div class="statusData">
                      <div :class="mobile ? 'mrvm' : 'rvm'">RVM</div>
                      <div :class="mobile ? 'mrvm moverflow' : 'rvm overflow'">
                        {{ $t("map.overflow") }}
                      </div>
                    </div>
                    <span :class="mobile ? 'mtotalDate' : 'totalDate'">{{
                      this.totalDate.overflow
                    }}</span>
                  </div>
                  <div
                    :class="mobile ? 'msearch msearch1' : 'search search1'"
                    @click="jumptoMachine(totalDate, 'overflow')"
                  >
                    {{ $t("map.view") }}
                  </div>
                </div>
              </div>
            </el-card>
            <el-card class="img3">
              <div>
                <img
                  src="@/assets/images/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'ja'"
                />
                <img
                  src="@/assets/imagesHK/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'HK'"
                />
                <img
                  src="@/assets/imagesKegoo/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Kegoo'"
                />
                <img
                  src="@/assets/imagesMINI/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'MINI'"
                />
                <img
                  src="@/assets/imagesOlar/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Olar'"
                />
                <img
                  src="@/assets/imagesHKCarton/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'Carton'"
                />
                <img
                  src="@/assets/imagesJAMINI/RVM2.png"
                  alt=""
                  style="width: 50%; heigh: 50%"
                  v-if="urlFile == 'JAMINI'"
                />
                <div class="statusNum">
                  <div :class="mobile ? 'mstatusData1' : 'statusData1'">
                    <div class="statusData">
                      <div :class="mobile ? 'mrvm' : 'rvm'">RVM</div>
                      <div :class="mobile ? 'mrvm merror' : 'rvm error'">
                        {{ $t("map.error") }}
                      </div>
                    </div>
                    <span :class="mobile ? 'mtotalDate' : 'totalDate'">{{
                      this.totalDate.error
                    }}</span>
                  </div>
                  <div
                    :class="mobile ? 'msearch msearch2' : 'search search2'"
                    @click="jumptoMachine(totalDate, 'error')"
                  >
                    {{ $t("map.view") }}
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </el-row>
      </div>
      <!-- 地图模块 -->
      <div
        class="item2"
        data-step="2"
        :data-intro="$t('map.intro.dataIntro2')"
        :data-title="$t('map.intro.dataTitle2')"
      >
        <el-card
          style="
            height: 100%;
            position: relative;
            padding: 0;
            margin: 0px 10px 0 0px;
          "
          shadow
        >
          <div
            @click="jumpToMap"
            style="width: 100%; position: absolute"
            alt=""
            class="HKmap"
          >
            <img
              src="@/assets/images/map.png"
              style="width: 100%"
              v-if="urlFile == 'ja'"
            />
            <img
              src="@/assets/imagesHK/map.png"
              style="width: 100%"
              v-if="urlFile == 'HK'"
            />
            <img
              src="@/assets/imagesMINI/map.png"
              style="width: 100%"
              v-if="urlFile == 'MINI'"
            />
            <img
              src="@/assets/imagesOlar/map.png"
              style="width: 100%"
              v-if="urlFile == 'Olar'"
            />
            <img
              src="@/assets/imagesHKCarton/map.png"
              style="width: 100%"
              v-if="urlFile == 'Carton'"
            />
            <img
              src="@/assets/imagesJAMINI/map.png"
              style="width: 100%"
              v-if="urlFile == 'JAMINI'"
            />
          </div>

          <div
            class="tabs"
            style="
              height: 40%;
              width: 100%;
              position: absolute;
              display: flex;
              flex-direction: column;
              overflow: auto;
              top: 60%;
              border: none;
            "
          >
            <!-- <div class="leftArrow" @click="minValPlus" v-if="arrowShow"></div>
            <div class="rightArrow" @click="maxValPlus" v-if="arrowShow"></div> -->
            <el-tabs
              type="border-card"
              style="
                width: 100%;
                position: absolute;
                display: flex;
                flex-direction: column;
                overflow: auto;

                border: none;
              "
              @tab-click="changeShowAddress"
            >
              <el-tab-pane name="0">
                <div slot="label" class="slotLabel is-active">
                  {{ $t("map.mapTableTitle") }}
                </div>
                <div
                  style="
                    flex: 1;
                    overflow-y: auto;
                    position: relative;
                    height: 100%;
                  "
                >
                  <div v-for="item in mapInfo" :key="item.id">
                    <el-progress
                      :percentage="item.overflow ? item.overflow.overflow : 0"
                    ></el-progress
                    ><span style="font-size: 12px">{{ item.pdescribe }}</span>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="!tableDistrict.length" name="nonetab" disabled>
                <div slot="label" class="slotLabel"></div>
              </el-tab-pane>
              <el-tab-pane
                v-for="item in tableDistrict"
                :name="item.value.toString()"
                :key="item.value"
              >
                <div slot="label" class="slotLabel">
                  {{ item.label }}
                </div>
                <div
                  style="
                    flex: 1;
                    overflow-y: auto;
                    position: relative;
                    height: 100%;
                  "
                >
                  <div v-for="item2 in mapInfo" :key="item2.id">
                    <el-progress
                      :percentage="item2.overflow ? item2.overflow.overflow : 0"
                    ></el-progress
                    ><span style="font-size: 12px">{{ item2.pdescribe }}</span>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </div>
      <!-- 上月每日回收量 -->
      <div
        class="item3"
        data-step="3"
        :data-intro="$t('map.intro.dataIntro3')"
        :data-title="$t('map.intro.dataTitle3')"
      >
        <el-card style="margin: 0px 10px 0 0px">
          <div
            id="main"
            :style="{ width: '100%', height: '20rem', overflow: 'hidden' }"
          ></div
        ></el-card>
      </div>
      <!-- 累计回收瓶子 -->
      <div
        class="item4"
        data-step="4"
        :data-intro="$t('map.intro.dataIntro4')"
        :data-title="$t('map.intro.dataTitle4')"
      >
        <el-card class="total" style="margin: 0px 10px 0 0px">
          <div style="display: flex"></div>
          <div class="wenzi">{{ $t("map.bottleTotal") }}</div>
          <div
            style="display: flex; flex-direction: row; height: 60%; gap: 20px"
          >
            <div class="showimg4">
              <div class="img4" v-if="urlFile == 'ja'"></div>
              <div class="img5" v-if="urlFile == 'HK'"></div>
              <div class="img6" v-if="urlFile == 'MINI'"></div>
              <div class="img7" v-if="urlFile == 'Olar'"></div>
              <div class="img7" v-if="urlFile == 'Kegoo'"></div>
              <div class="img7" v-if="urlFile == 'Carton'"></div>
              <div class="img8" v-if="urlFile == 'JAMINI'"></div>
            </div>

            <div
              style="
                flex: 1;
                vertical-align: middle;
                display: flex;
                width: 150px;
              "
            >
              <span class="Img4total" v-if="RecycleTotal">{{
                this.RecycleTotal
              }}</span>
              <span class="Img4total" v-else>0</span>
            </div>
          </div>
        </el-card>
      </div>
      <!-- 回赠方式 -->
      <!-- <div class="item5">
        <el-card class="total" style="margin: 0px 10px 0 0px">
          <div class="wenzi">{{ $t("map.platForm") }}</div>
          <div
            style="margin-left: 20px; display: flex; margin-bottom: 20px"
            v-if="circleList"
          >
            <div
              class="progress"
              v-for="(item, index) in circleList"
              :key="index"
            >
              <el-progress
                type="circle"
                :stroke-width="20"
                :percentage="item.valuePercentage"
                :color="CircleColor[index]"
              ></el-progress>
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div v-else>
            <el-empty :description="$t('publicFile.noData')"></el-empty>
          </div>
        </el-card>
      </div> -->
    </div>
  </div>
</template>

<script>
// import intro from "intro.js";

import * as echarts from "echarts";
import { mapGetters, mapState } from "vuex";
import {
  computedYLegnth,
  formatEveryDay,
  timestamp,
} from "@/utils/DataAnalysis";
export default {
  data() {
    return {
      string: null,
      totalDate: 12,
      mapInfo: "",
      setColor: "",
      color: "",
      greenCircleColor: ["#86deac", "#75be79", "#2e947c"],
      blueCircleColor: ["#87c0de", "#63c3cf", "#2a77bb"],
      CircleColor: null,
      // 日期列表
      dateList: [],
      // 回收类型
      RecycleTypeList: [],
      typeName: [],
      TotalDate:
        process.env.VUE_APP_API_BASE_NAME == "hk" &&
        localStorage.getItem("project") == "18"
          ? [1776441600000, new Date().setHours(0, 0, 0, 0)]
          : [1696089600000, new Date().setHours(0, 0, 0, 0)],
      RecycleTotal: null,
      circleList: null,
      mobile: "",
      myChart: "",
      // 表格头部地区列表
      tableDistrict: "",
      urlFile: "",
      arrowShow: true,
      userProject: "",
      // 根据id查询設備信息
      params: {
        mid: "",
      },
    };
  },
  computed: {
    ...mapGetters(["theme", "sidebar"]),
  },
  mounted() {
    this.IsPC();
    (this.color = window.document.documentElement.getAttribute("data-theme")),
      (this.setColor = "");
    if (this.color == "green") {
      this.setColor = "#4dc170";
      this.CircleColor = this.greenCircleColor;
    } else if (this.color == "blue") {
      this.CircleColor = this.blueCircleColor;
      this.setColor = "#3aaee9";
    }
    this.getTotal();
    this.getMachineInfo();
    this.getdateList();
    this.getDistrict();
    // this.drawLine();
    // this.getpercentage();
    this.totalRecycle();
    this.getplatform();
    if (process.env.VUE_APP_API_BASE_NAME == "hk") {
      if (localStorage.getItem("project") == "16") {
        this.urlFile = "Kegoo";
      }
      if (localStorage.getItem("project") == "18") {
        this.urlFile = "Carton";
      } else {
        this.urlFile = "HK";
      }
    } else if (process.env.VUE_APP_API_BASE_NAME == "ja") {
      this.urlFile = "ja";
      if (localStorage.getItem("project") == "17") {
        this.urlFile = "JAMINI";
      }
    } else if (process.env.VUE_APP_API_BASE_NAME == "mini") {
      this.urlFile = "MINI";
    } else if (process.env.VUE_APP_API_BASE_NAME == "olar") {
      this.urlFile = "Olar";
    }
    // console.log(document.querySelector(".el-tabs__nav"), 9999);
    // document.querySelector(".el-tabs__nav").addEventListener("click", (e) => {
    //   console.log(e.target);
    //   e.target.classList.add("is-active");
    // });
    // this.arrowShowFn();
    if (localStorage.getItem("isFirst") == "true") {
      setTimeout(() => {
        this.setGuide();
      }, 500);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.myChart.resize());
  },
  methods: {
    setGuide() {
      introJs()
        .setOptions({
          // 我给看的效果图是英文的（默认英文），这里是更换成中文
          prevLabel: this.$t("map.intro.prevLabel"),
          nextLabel: this.$t("map.intro.nextLabel"),
          skipLabel: this.$t("map.intro.skipLabel"),
          doneLabel: this.$t("map.intro.doneLabel"),
          // steps步骤，可以写个工具类保存起来
          // steps: steps,
        })
        .oncomplete(() => {
          // 需要注意的是，这里用了箭头函数
          // 点击结束按钮后执行的事件
          localStorage.setItem("isFirst", false);
        })
        .onexit(() => {
          // 点击跳过按钮后执行的事件
          localStorage.setItem("isFirst", false);
        })
        .onbeforeexit(() => {
          // 确认完毕之后执行的事件
          // return confirm('Are you sure?')
        })
        .onbeforechange(function (targetElement) {
          targetElement.scrollIntoView({
            // behavior: "smooth",
            block: "center",
          });
        })
        .start();
    },
    minValPlus() {
      if (this.minVal >= 3) {
        this.minVal -= 3;
        this.maxVal -= 3;
        if (this.activeName >= 4) {
          // this.activeName = (Number(this.activeName) - 3).toString();
          this.changeShowAddress({
            name: (Number(this.activeName) - 3).toString(),
          });
        }
      }
    },
    maxValPlus() {
      if (
        this.tableDistrict.length >= 3 &&
        this.minVal <= this.tableDistrict.length - 3
      ) {
        this.minVal += 3;
        this.maxVal += 3;
        if (this.activeName !== "1") {
          // this.activeName = (Number(this.activeName) + 3).toString();
          this.changeShowAddress({
            name: (Number(this.activeName) + 3).toString(),
          });
        }
        if (
          this.activeName >
          this.tableDistrict[this.tableDistrict.length - 1].value
        ) {
          // this.activeName =
          //   this.tableDistrict[this.tableDistrict.length - 1].value.toString();
          this.changeShowAddress({
            name: this.tableDistrict[
              this.tableDistrict.length - 1
            ].value.toString(),
          });
        }
      }
    },
    arrowShowFn() {
      let tab = document.querySelector(".list");
      tab.addEventListener(
        "mouseenter",
        () => {
          this.arrowShow = true;
        },
        false
      );
      tab.addEventListener(
        "mouseleave",
        () => {
          this.arrowShow = false;
        },
        false
      );
    },
    fontSize() {
      if (this.mobile) {
        return 1.5 + "vw";
      } else {
        return 22;
      }
    },
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    // 获得日期列表
    async getdateList() {
      var nowdays = new Date();
      var year = nowdays.getFullYear();
      var month = nowdays.getMonth();
      if (month == 0) {
        month = 12;
        year = year - 1;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var myDate = new Date(year, month, 0);
      var startDate = year + "-" + month + "-01 00:00:00"; //上个月第一天
      var endDate = year + "-" + month + "-" + myDate.getDate() + " 23:59:00"; //上个月最后一天
      let time = [];
      this.typeName = [];
      time[0] = new Date(startDate).getTime();
      time[1] = new Date(endDate).getTime();
      this.dateList = formatEveryDay(timestamp(startDate), timestamp(endDate));
      let RecycleTypeList = await this.getAllType();
      let list = [];
      // RecycleTypeList.push(
      //   {
      //     name: "塑料瓶",
      //   },
      //   {
      //     name: "易拉罐",
      //   }
      // );
      RecycleTypeList.forEach((item) => {
        let params = {
          dates: null,
          recycleTypeId: [],
        };
        params.dates = time;
        params.recycleTypeId.push(item.id);
        list.push(params);
        this.typeName.push(item.name);
      });
      this.recycleTypeNum(list);
    },
    getProjectList() {
      let res = this.$http.project.getProject();
      console.log(res, "888");
      return res;
    },
    //获得表头地区
    async getDistrict() {
      let params = {};
      let res1 = await this.getProjectList();
      let districtId;
      res1.datas.forEach((item) => {
        if (localStorage.getItem("project") == item.id) {
          districtId = item.districtId;
        }
      });
      params.pid = districtId || 6;
      let res = await this.$http.district.getDistrict(params);
      const nodes = await res.datas.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      this.tableDistrict = nodes;
      setTimeout(() => {
        var arr = document.getElementsByClassName("slotLabel");
        // arr[0].classList.add("is-active");
        for (let i = 0; i < arr.length; i++) {
          arr[i].onclick = function () {
            arr[i].classList.add("is-active");
            for (let j = 0; j < arr.length; j++) {
              if (j != i) {
                arr[j].classList.remove("is-active");
              }
            }
          };
        }
      }, 10);
    },
    // 修改显示区域
    changeShowAddress(val) {
      let params = {};
      if (val.name == 0) {
        params.region = 6;
        this.getMachineInfo();
      } else {
        params.region = val.name;
        this.getMachineInfo(params);
      }
    },
    // 地图设备搜索
    getMachineInfo(params) {
      this.mapInfo = [];
      this.$http.map.getMachineInfo(params).then((res) => {
        this.mapInfo = res;
        this.mapInfo.forEach((item) => {
          item.overflows.forEach((item2) => {
            if (item2.rid == 1) {
              item.overflow = item2;
            }
          });
        });
      });
    },
    // 获得所有回收类型
    async getAllType() {
      let res = await this.$http.recycletype.getRecycletype();
      let RecycleTypeList = [];
      if (res.code == 200) {
        res.datas.forEach((item) => {
          if (item.enable) {
            RecycleTypeList.push(item);
          }
        });
        return RecycleTypeList;
      }
    },
    // 回收物总数
    async recycleTypeNum(list) {
      let typedataList = [];
      for (const item of list) {
        let res = await this.$http.analysis.getrecycleTypeNum(item);
        if (res.code == 200) {
          let i = 0;
          let recycleTypeNumList = [];
          this.dateList.forEach((item2, index) => {
            let a = "/";
            let itemDate =
              item2.replace(new RegExp(a, "g"), "-") + "T00:00:00+08:00";
            if (
              res.datas[i] &&
              res.datas[i].date == new Date(itemDate).getTime()
            ) {
              recycleTypeNumList.push(res.datas[i].total);
              i++;
            } else {
              recycleTypeNumList.push(0);
            }
          });
          typedataList.push(recycleTypeNumList);
        }
      }
      // line图中series配置
      let series = this.series(typedataList);
      setTimeout(() => {
        if (typedataList.length >= 0) {
          this.drawLine(series);
        }
      }, 500);
    },
    series(typedataList) {
      let series = [];
      let color = [
        {
          one: "rgb(0,255,127,1)",
          two: "rgb(0,255,127,0)",
        },
        {
          one: "rgb(255,165,0,1)",
          two: "rgb(255,165,0,0)",
        },
        {
          one: "rgb(251,122,122,1)",
          two: "rgb(251,122,122,0)",
        },
        {
          one: "rgb(0,0,0,1)",
          two: "rgb(0,0,0,0)",
        },
      ];
      for (let index = 0; index < typedataList.length; index++) {
        series.push({
          name: this.typeName[index],
          type: "line",
          stack: "Total",
          smooth: true,
          lineStyle: {
            width: 0,
          },
          showSymbol: false,
          data: typedataList[index],
          areaStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(1, 0, 1, 1, [
              {
                offset: 0,
                color: color[index].one,
              },
              {
                offset: 1,
                color: color[index].two,
              },
            ]),
          },
          emphasis: {
            focus: "series",
          },
        });
      }
      return series;
    },
    drawLine(params) {
      if (this.myChart) {
        this.myChart = "";
      }
      var chartDom = document.getElementById("main");
      this.myChart = echarts.init(chartDom);
      var option;
      option = {
        color: ["#80FFA5", "#ea9518", "rgb(251,122,122)", "rgb(0,0,0)"],
        title: {
          text: this.$t("map.DailyRecycling"),
          textStyle: {
            fontSize: this.fontSize(),
            fontWeight: "normal",
            color: "rgba(0,0,0,1)",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        legend: {
          data: this.typeName,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          with: "100%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.dateList,
            axisLabel: {
              //x轴文字的配置
              rotate: 90,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: function (value, index) {
                if (value >= 1000) {
                  return value / 1000 + "k";
                } else if (value >= 100000) {
                  return value / 1000 + "k";
                } else if (value >= 1000000) {
                  return value / 1000 + "k";
                } else if (value >= 10000000) {
                  return value / 1000 + "k";
                } else if (value >= 100000000) {
                  return value / 1000 + "k";
                } else {
                  return value;
                }
              },
            },
          },
        ],
        series: params,
      };

      option && this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        // 第六步，执行echarts自带的resize方法，即可做到让echarts图表自适应
        this.myChart.resize();
      });
    },
    jumpToMap() {
      this.$router.push({ path: "map" });
    },
    getTotal() {
      this.$http.cd.gettotal().then((res) => {
        this.totalDate = res;
      });
    },
    // 回收总数
    totalRecycle() {
      let params = {};
      params.dates = this.TotalDate;
      this.$http.analysis.getTotalRecycle(params).then((res) => {
        if (res.code == 200) {
          this.RecycleTotal = (res.datas || 0)
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
      });
    },
    // 获得信息
    getplatform() {
      this.$http.platform.getplatform().then((res) => {
        if (res.code == 200) {
          this.getpercentage(res.datas);
        }
      });
    },
    // 获得饼图数据
    async getpercentage(value) {
      let platList = value;
      let params = {};
      params.dates = this.TotalDate;
      await this.$http.analysis.getpercentage(params).then((res) => {
        if (res.code == 200) {
          res.datas.forEach((item) => {
            for (let index = 0; index < platList.length; index++) {
              if (item.platformId == platList[index].id) {
                item.name = platList[index].name;
              }
            }
          });
          this.circleList = res.datas;
        }
      });
    },
    jumptoMachine(val, value) {
      this.$router.push({ path: "device", query: { state: value } });
    },
  },
  watch: {
    theme: {
      immediate: true,
      handler: function (newval) {
        this.color = newval;
        if (this.color == "green") {
          this.setColor = "#4dc170";
          this.CircleColor = this.greenCircleColor;
        } else if (this.color == "blue") {
          this.CircleColor = this.blueCircleColor;
          this.setColor = "#3aaee9";
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
/deep/.el-tabs__nav-scroll {
  border-radius: 20px 20px 0 0 !important;
  color: white;
  display: flex;
  flex-direction: column;
  background: white !important;
}
/* /deep/ .el-tabs__nav-wrap .is-top {
  width: 100px;
  border-radius: 20px 20px 0 0;
  color: white;
} */
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item + .el-tabs__item,
.el-tabs--border-card > .el-tabs__header .el-tabs__item:first-child {
  margin: 0;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: white;
  font-weight: bold;
  border-radius: 5px 5px 0 0;
  /* width: calc(100% / 4); */
  text-align: center;
  box-sizing: border-box;
  padding: 0;
  /* flex: 1; */
  border-radius: 0px;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item:last-child {
  /* margin-right: 20px; */
}
/deep/.el-tabs--border-card > .el-tabs__header {
  border-bottom: none;
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  font-weight: bold;
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: none;
}
/deep/.el-tabs__item .is-top {
  width: 100px;
  flex-grow: 1;
}
/deep/.item2 .el-card__body {
  padding: 0 !important;
}
/deep/.item2 .el-card {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
}
/deep/.el-tabs__content {
  flex: 5;
  /* background-color: red; */
  overflow: auto;
}
/deep/.el-tabs__header {
  flex: 1;
}
/deep/.el-tab-pane {
  height: 100%;
}
.pc {
  .statusList {
    padding-right: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  .statusNum {
    width: 40%;
    float: right;
    text-align: center;
    .statusData {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      justify-content: center;
    }
    .rvm {
      font-size: 1.1vw;
      font-weight: 550;
    }
    .search {
      width: 5vw;
      height: 2.2vw;
      border-radius: 2.2vw;
      background: #85c8a9;
      color: white;
      font-size: 0.9vw;
      text-align: center;
      line-height: 2.2vw;
      cursor: pointer;
    }
    .search1 {
      background: #fb7a7a;
    }
    .search2 {
      background: rgb(180, 180, 180);
    }
    .online {
      color: #53c18f;
    }
    .error {
      color: rgb(180, 180, 180);
    }
    .overflow {
      color: #fb7a7a;
    }
    .totalDate {
      font-size: 3vw;
      font-weight: 700;
    }
    .statusData1 {
      height: 7vw;
    }
  }
}
/* .msearch {
  width: 5vw;
  height: 2.2vw;
  border-radius: 1vw;
  background: #85c8a9;
  color: white;
  font-size: 28px;
  text-align: center;
  line-height: 2.2vw;
  cursor: pointer;
  margin-left: 1vw;
}
.msearch1 {
  background: #fb7a7a;
}
.msearch2 {
  background: rgb(180, 180, 180);
}
.mrvm {
  font-size: calc(28px);
}
.merror {
  color: rgb(180, 180, 180);
}
.moverflow {
  color: #fb7a7a;
} */

.mobile {
  .container {
    flex-direction: column;
  }
  /* .rvm {
    font-size: calc(1.5vw);
  } */
  .wenzi {
    font-size: calc(2.5vw);
    font-weight: 800;
    color: rgba(0, 0, 0, 1);
  }
  /* .search {
    width: 5vw;
    height: 2.2vw;
    border-radius: 1vw;
    background: #85c8a9;
    color: white;
    font-size: 1.5vw;
    text-align: center;
    line-height: 2.2vw;
    cursor: pointer;
  }
  .search1 {
    background: #fb7a7a;
  }
  .search2 {
    background: rgb(180, 180, 180);
  } */
  .statusList {
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  .statusNum {
    width: 40%;
    float: right;
    text-align: center;
    /* margin-top: calc(-5vw); */
  }
  .Img4total {
    flex: 1;
    font-size: 2rem;
    font-weight: 800;
    margin: auto;
    margin-left: 0;
  }
  .HKmap {
    /* width: 100%;
  height: 100%; */
    width: 50vh;
    padding: 20px 40px;
    /* background-color: red; */
    /* margin: 20px; */
    /* margin-top: 10px;
  margin-left: 56px; */
  }
  .HKmapMain {
    flex-grow: 2;
    width: 50vh;
  }
  .tabs {
    top: 50%;
  }
}

.container {
  display: grid;
  grid-template-columns: 59% 40%;
  grid-gap: 10px;
  width: 100%;
  padding: 20px;
  padding-bottom: 55px;
  overflow-y: hidden;
}

.item2 {
  grid-column-start: 2;
  grid-row: 1 / 4;
  overflow: hidden;
  grid-template-rows: 100%;
}
@media only screen and (max-width: 1000px) {
  .container {
    grid-template-columns: 1fr;
  }
  .item2 {
    height: 950px;
    grid-column-start: 1;
    grid-row: 2 / 3;
  }
}

/* 图片 */
.statusList {
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.statusNum {
  width: 40%;
  float: right;
  text-align: center;
}
.totalDate {
  font-size: 1.5vw;
}
.img1 {
  flex: 1;
  border-radius: 30px;
  padding: 10px 0px;
}
.img1 span {
  color: #53c18f;
}

.img2 {
  flex: 1;
  border-radius: 30px;
  padding: 10px 0px;
  margin-left: 15px;
}
.img2 span {
  color: #fd5454;
}
.img3 {
  flex: 1;
  border-radius: 30px;
  padding: 10px 0px;
  margin-left: 15px;
}
.img3 span {
  color: #ababab;
}
.item1-container {
  display: grid;
  overflow: hidden;
}
.total .wenzi {
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 1);
}
.showimg4 {
  flex: 1;
  display: flex;
}
.img4,
.img5,
.img6,
.img7,
.img8 {
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.Img4total {
  flex: 1;
  font-size: 60px;
  font-weight: 800;
  margin: auto;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0;
}
.HKmap {
  /* width: 100%;
  height: 100%; */
  width: 100%;
  padding: 20px 40px;
  /* background-color: red; */
  /* margin: 20px; */
  /* margin-top: 10px;
  margin-left: 56px; */
}
.HKmapMain {
  flex-grow: 2;
  width: 98.5%;
}

.item4 {
  display: flex;
  height: 100%;
}
.item4 .el-card {
  width: 100%;
  /* background-color: red; */
}
.item4 /deep/.el-card .el-card__body {
  height: 100%;
  /* background-color: #53c18f !important; */
}

.progress {
  flex: 1;
  margin-right: 60px;
  margin-top: 10px;
  height: 135px;
  width: 127px;
}

.progress1 {
  display: inline-block;
  margin-right: 36px;
  width: 127px;
}
.progress span {
  display: inline-block;
  height: 27px;
  width: 127px;
  text-align: center;
  font-size: 15px;
}
.progress1 span {
  display: inline-block;
  box-sizing: border-box;
  width: 127px;
  text-align: center;
  font-size: 15px;
}

/* /deep/.el-tabs__item.is-active::before {
  width: 10px;
  height: 10px;
  position: absolute;
  left: -10px;
  bottom: -1px;
  border: none;
  background: url("../../assets/mapImg/圆角.png");
  background-size: 10px 10px;
  padding: 0;
  transform: rotate(-90deg);
  content: "";
}
/deep/.el-tabs__item.is-active::after {
  width: 10px;
  height: 10px;
  position: absolute;
  right: -10px;
  bottom: -1px;
  border: none;
  background: url("../../assets/mapImg/圆角.png");
  background-size: 10px 10px;
  padding: 0;
  content: "";
} */

/deep/.el-tabs__item.is-active + .el-tabs__item > .slotLabel {
  /* color: #fd5454; */
  border-bottom-left-radius: 10px !important;
}

/deep/ .el-tabs__item:has(+ .el-tabs__item.is-active) > .slotLabel {
  border-bottom-right-radius: 10px !important;
}

/deep/.el-tabs__item.is-active {
  background: #85c8a9 !important;
}
.is-active {
  border-radius: 10px 10px 0 0;
  background: white !important;
}
/deep/.el-tabs__item {
  background: #85c8a9;
  /* border-radius: 0px; */
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
.slotLabel {
  background: #85c8a9;
}

/deep/.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(:first-child) {
  flex: 1;
  /* width: 125px; */

  border-radius: 0px;
}
/deep/#tab-0 {
  width: 125px !important;
}
/deep/.el-tabs__nav {
  display: flex;
  align-items: flex-end;
}
/deep/.el-tabs--top.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:nth-child(2) {
  padding-left: 0;
}
/deep/.el-tabs--top.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:last-child {
  padding-right: 0;
}
.leftArrow {
  position: absolute;
  z-index: 1000;
  margin-top: 15px;
  left: 125px;
  width: 0;
  height: 0;
  border: 8px solid;
  border-color: transparent transparent transparent rgb(83, 168, 133);
}
.rightArrow {
  position: absolute;
  z-index: 1000;
  margin-top: 15px;
  right: 0px;
  width: 0;
  height: 0;
  border: 8px solid;
  border-color: transparent rgb(83, 168, 133) transparent transparent;
}
.container {
  @media screen and (min-width: 0px) and (max-width: 1000px) {
    .msearch {
      width: 100px;
      height: 40px;
      border-radius: 40px;
      background: #85c8a9;
      color: white;
      font-size: 28px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      margin-left: 0px;
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: calc(28px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 28px;
    }
    .mtotalDate {
      font-size: 60px;
    }
  }

  @media screen and (min-width: 1001px) and (max-width: 1500px) {
    .msearch {
      width: clamp(60px, calc(6vw), 70px);
      /* width: 9vw; */
      height: clamp(30px, calc(2.5vw), 35px);
      /* height: 35px; */
      border-radius: clamp(30px, calc(2.5vw), 35px);
      background: #85c8a9;
      color: white;
      font-size: clamp(12px, calc(2vw), 24px);
      /* font-size: 2vw; */
      text-align: center;
      line-height: clamp(30px, calc(2.5vw), 35px);
      cursor: pointer;
      margin-left: clamp(0px, calc(0.5vw), 5px);
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(12px, calc(2vw), 24px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(40px, calc(5vw), 50px);
      /* font-size: 5vw; */
    }
  }

  @media screen and (min-width: 1501px) and (max-width: 2000px) {
    .msearch {
      width: clamp(80px, calc(6vw), 100px);
      /* width: 6vw; */
      height: clamp(40px, calc(4vw), 60px);
      /* height: 3vw; */
      border-radius: clamp(40px, calc(4vw), 60px);
      background: #85c8a9;
      color: white;
      font-size: clamp(20px, calc(1.5vw), 30px);
      /* font-size: 1.5vw; */
      text-align: center;
      line-height: clamp(40px, calc(4vw), 60px);
      cursor: pointer;
      margin-left: clamp(5px, calc(2vw), 10px);
      /* margin-left: 2vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(20px, calc(1.5vw), 30px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(60px, calc(5vw), 70px);
      /* font-size: 5vw; */
    }
  }

  @media screen and (min-width: 2001px) and (max-width: 3000px) {
    .msearch {
      width: clamp(100px, calc(6vw), 120px);
      /* width: 6vw; */
      height: clamp(45px, calc(3vw), 55px);
      /* height: 3vw; */
      border-radius: clamp(45px, calc(3vw), 55px);
      background: #85c8a9;
      color: white;
      font-size: clamp(30px, calc(2vw), 40px);
      /* font-size: 2vw; */
      text-align: center;
      line-height: clamp(45px, calc(3vw), 55px);
      cursor: pointer;
      margin-left: clamp(20px, calc(2vw), 30px);
      /* margin-left: 2vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(30px, calc(2vw), 40px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(90px, calc(5vw), 100px);
      /* font-size: 5vw; */
    }
  }
  @media screen and (min-width: 3000px) {
    .msearch {
      width: clamp(170px, calc(6vw), 180px);
      /* width: 6vw; */
      height: clamp(70px, calc(3vw), 80px);
      /* height: 3vw; */
      border-radius: clamp(70px, calc(3vw), 80px);
      background: #85c8a9;
      color: white;
      font-size: clamp(70px, calc(2vw), 80px);
      font-size: 2vw;
      text-align: center;
      line-height: clamp(70px, calc(3vw), 80px);
      cursor: pointer;
      margin-left: clamp(25px, calc(1vw), 30px);
      /* margin-left: 1vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(70px, calc(2vw), 80px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(140px, calc(5vw), 150px);
      /* font-size: 5vw; */
    }
  }
}
.container1 {
  @media screen and (min-width: 0px) and (max-width: 1000px) {
    .msearch {
      width: 80px;
      height: 40px;
      border-radius: 40px;
      background: #85c8a9;
      color: white;
      font-size: 20px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      margin-left: 0px;
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: calc(20px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 20px;
    }
    .mtotalDate {
      font-size: 50px;
    }
  }

  @media screen and (min-width: 1001px) and (max-width: 1500px) {
    .msearch {
      width: clamp(90px, calc(9vw), 110px);
      /* width: 9vw; */
      height: clamp(45px, calc(4vw), 60px);
      /* height: 4vw; */
      border-radius: clamp(45px, calc(4vw), 60px);
      background: #85c8a9;
      color: white;
      font-size: clamp(30px, calc(3vw), 35px);
      /* font-size: 3vw; */
      text-align: center;
      line-height: clamp(45px, calc(4vw), 60px);
      cursor: pointer;
      margin-left: clamp(0px, calc(0.5vw), 5px);
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(30px, calc(3vw), 35px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(70px, calc(6vw), 80px);
      /* font-size: 6vw; */
    }
  }

  @media screen and (min-width: 1501px) and (max-width: 2000px) {
    .msearch {
      width: clamp(150px, calc(8vw), 160px);
      /* width: 8vw; */
      height: clamp(70px, calc(4vw), 80px);
      /* height: 4vw; */
      border-radius: clamp(70px, calc(4vw), 80px);
      background: #85c8a9;
      color: white;
      font-size: clamp(40px, calc(3vw), 50px);
      /* font-size: 3vw; */
      text-align: center;
      line-height: clamp(70px, calc(4vw), 80px);
      cursor: pointer;
      margin-left: clamp(10px, calc(1.5vw), 20px);
      /* margin-left: 1.5vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(40px, calc(3vw), 50px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(120px, calc(8vw), 140px);
      /* font-size: 8vw; */
    }
  }

  @media screen and (min-width: 2001px) and (max-width: 2500px) {
    .msearch {
      width: clamp(200px, calc(9vw), 210px);
      /* width: 9vw; */
      height: clamp(90px, calc(4vw), 100px);
      /* height: 4vw; */
      border-radius: clamp(90px, calc(4vw), 100px);
      background: #85c8a9;
      color: white;
      font-size: clamp(70px, calc(3vw), 80px);
      /* font-size: 3vw; */
      text-align: center;
      line-height: clamp(90px, calc(4vw), 100px);
      cursor: pointer;
      margin-left: clamp(25px, calc(2vw), 35px);
      /* margin-left: 2vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(70px, calc(3vw), 80px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(150px, calc(7vw), 160px);
      /* font-size: 7vw; */
    }
  }
  @media screen and (min-width: 2501px) and (max-width: 3000px) {
    .msearch {
      width: clamp(260px, calc(9vw), 280px);
      /* width: 9vw; */
      height: clamp(150px, calc(4vw), 160px);
      /* height: 4vw; */
      border-radius: clamp(150px, calc(4vw), 160px);
      background: #85c8a9;
      color: white;
      font-size: clamp(90px, calc(3.5vw), 100px);
      /* font-size: 3.5vw; */
      text-align: center;
      line-height: clamp(150px, calc(4vw), 160px);
      cursor: pointer;
      margin-left: clamp(25px, calc(2vw), 35px);
      /* margin-left: 2vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(90px, calc(3.5vw), 100px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(150px, calc(7vw), 160px);
      /* font-size: 7vw; */
    }
  }
  @media screen and (min-width: 3000px) {
    .msearch {
      width: clamp(320px, calc(10vw), 340px);
      /* width: 10vw; */
      height: clamp(110px, calc(5vw), 160px);
      /* height: 5vw; */
      border-radius: clamp(110px, calc(5vw), 160px);
      background: #85c8a9;
      color: white;
      font-size: clamp(80px, calc(4vw), 120px);
      /* font-size: 4vw; */
      text-align: center;
      line-height: clamp(110px, calc(5vw), 160px);
      cursor: pointer;
      margin-left: clamp(30px, calc(2vw), 40px);
      /* margin-left: 2vw; */
    }
    .msearch1 {
      background: #fb7a7a;
    }
    .msearch2 {
      background: rgb(180, 180, 180);
    }
    .mrvm {
      font-size: clamp(80px, calc(4vw), 120px);
    }
    .merror {
      color: rgb(180, 180, 180);
    }
    .moverflow {
      color: #fb7a7a;
    }
    .statusData1 {
      height: 7vw;
    }
    .mtotalDate {
      font-size: clamp(230px, calc(7vw), 240px);
      /* font-size: 7vw; */
    }
  }
}
</style>
